"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _core = require("@material-ui/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      maxWidth: "100%",
      paddingTop: "42.8571%",
      position: "relative",
      overflow: "hidden",
      borderRadius: theme.shape.borderRadius * 4
    },
    inner: {
      position: "absolute",
      top: 0,
      height: "calc(100% + ".concat(theme.spacing(1), "px)"),
      width: "calc(100% + ".concat(theme.spacing(2), "px)")
    },
    imageWrap: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      objectPosition: "center",
      position: "absolute!important"
    },
    single: {
      height: "100%"
    },
    col: {
      position: "relative",
      backgroundPosition: "center center",
      backgroundSize: "cover",
      width: "100%",
      height: "100%",
      overflow: "hidden"
    },
    fab: {
      position: "absolute",
      bottom: theme.spacing(2),
      right: theme.spacing(2)
    }
  };
});

// imageComponent only supports gatsby image
var Image = function Image(props) {
  return props.imageComponent ? /*#__PURE__*/_react["default"].createElement(props.imageComponent, {
    className: props.className,
    image: props.image.imageFile,
    alt: props.image.src || "",
    placeholder: "blurred",
    loading: "eager",
    blurredOptions: {
      quality: 40
    }
  }) : /*#__PURE__*/_react["default"].createElement("img", {
    className: props.className,
    src: props.image.path,
    alt: "boat image"
  });
};
function ImageGrid(_ref) {
  var images = _ref.images,
    onShowMore = _ref.onShowMore,
    imageComponent = _ref.imageComponent;
  var _useStyles = useStyles(),
    root = _useStyles.root,
    inner = _useStyles.inner,
    col = _useStyles.col,
    single = _useStyles.single,
    fab = _useStyles.fab,
    imageWrap = _useStyles.imageWrap,
    item = _useStyles.item;
  var imgGRef = (0, _react.useRef)();

  // calcCol is just for 3 - 5 cols
  var calcCol = function calcCol(i) {
    // l is lenght of images subtracting the first 2 as they are taken care of
    var l = images.length - 2;
    switch (i) {
      case 0:
        return l > 1 ? 6 : 12;
      case 1:
        return l > 1 ? 6 : 12;
      case 2:
        return l > 2 ? 6 : 12;
      case 3:
        return 6;
      default:
        return 12;
    }
  };
  var showMore = function showMore(e) {
    e.stopPropagation();
    var firstImage = Array.from(imgGRef.current.getElementsByTagName("img")).filter(function (im) {
      return im.hasAttribute("data-main-image");
    })[0];
    firstImage.click();
    typeof onShowMore === "function" ? onShowMore() : firstImage ? firstImage.click() : console.warn("no image ref");
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: root,
    ref: imgGRef
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    className: (0, _classnames["default"])(inner, _defineProperty({}, single, images.length === 1)),
    spacing: images.length === 1 ? 0 : 1
  }, images.length <= 2 ? images.map(function (image, i) {
    return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      key: i,
      item: true,
      xs: images.length > 1 ? 6 : 12,
      className: item
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: col
    }, /*#__PURE__*/_react["default"].createElement(Image, {
      className: imageWrap,
      image: image,
      imageComponent: imageComponent
    })));
  }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true,
    xs: 6,
    className: item
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: col
  }, /*#__PURE__*/_react["default"].createElement(Image, {
    className: imageWrap,
    image: images[0],
    imageComponent: imageComponent
  }))), /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    item: true,
    xs: 6,
    spacing: 1,
    className: item
  }, images.slice(1, 5).map(function (image, i) {
    return /*#__PURE__*/_react["default"].createElement(_core.Grid, {
      key: i,
      item: true,
      xs: calcCol(i),
      className: item
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: col
    }, /*#__PURE__*/_react["default"].createElement(Image, {
      className: imageWrap,
      image: image,
      imageComponent: imageComponent
    })));
  })), images.length > 5 && images.slice(5, images.length).map(function (image, i) {
    return /*#__PURE__*/_react["default"].createElement("img", {
      key: "sub-".concat(i),
      style: {
        display: "none"
      },
      src: image.path,
      alt: "boat preview image"
    });
  }))), /*#__PURE__*/_react["default"].createElement(_core.Fab, {
    variant: "extended",
    className: fab,
    size: "medium",
    color: "primary",
    onClick: showMore
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "caption"
  }, "Show all (", images.length, ")")));
}
ImageGrid.propTypes = {
  images: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    path: _propTypes["default"].string
  })),
  onShowMore: _propTypes["default"].func,
  imageComponent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object])
};
var _default = exports["default"] = ImageGrid;